export default __webpack_public_path__ + "static/media/PresentationIcon.d1bf621e.svg";